import { PropTableValues } from "../../../../src/components";
import { StatisticSizes, StatisticSpacingValues } from '@primer/react-brand';
import * as React from 'react';
export default {
  PropTableValues,
  StatisticSizes,
  StatisticSpacingValues,
  React
};